import React, { useState } from 'react';
import { MessageCircle } from 'lucide-react';
import { whatsappNumber } from '../data/mockData';
import { useLanguage } from '../contexts/LanguageContext';

const langLabels = { en: 'EN', hr: 'HR', de: 'DE' };

export const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { t, language, changeLanguage } = useLanguage();

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      setIsMenuOpen(false);
    }
  };

  const handleWhatsAppClick = () => {
    const message = encodeURIComponent(t('whatsappGeneric'));
    if (window.gtag) { window.gtag('event', 'whatsapp_click', { event_category: 'engagement', event_label: 'header' }); }
    if (typeof window.fbq === 'function') { window.fbq('track', 'Contact', { content_name: 'header' }); }
    window.open(`https://wa.me/${whatsappNumber}?text=${message}`, '_blank');
  };

  return (
    <header className="site-header">
      <div className="header-container">
        <div className="header-logo">
          <span className="logo-text">Villa in Pietra</span>
        </div>

        <nav className="header-nav">
          <button onClick={() => scrollToSection('highlights')} className="nav-link">
            {t('nav.highlights')}
          </button>
          <button onClick={() => scrollToSection('location')} className="nav-link">
            {t('nav.location')}
          </button>
          <button onClick={() => scrollToSection('amenities')} className="nav-link">
            {t('nav.amenities')}
          </button>
          <button onClick={() => scrollToSection('reviews')} className="nav-link">
            {t('nav.reviews')}
          </button>
          <button onClick={() => scrollToSection('booking')} className="nav-link">
            {t('nav.availability')}
          </button>
        </nav>

        {/* Language Switcher */}
        <div className="lang-switcher" data-testid="lang-switcher">
          {Object.entries(langLabels).map(([code, label]) => (
            <button
              key={code}
              onClick={() => changeLanguage(code)}
              className={`lang-btn ${language === code ? 'active' : ''}`}
              data-testid={`lang-btn-${code}`}
            >
              {label}
            </button>
          ))}
        </div>

        <button onClick={handleWhatsAppClick} className="header-cta-button" data-testid="header-cta">
          <MessageCircle className="h-4 w-4" />
          <span className="cta-text">{t('nav.contactUs')}</span>
        </button>

        <button
          className="mobile-menu-toggle"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          aria-label="Toggle menu"
        >
          <span className={`hamburger-line ${isMenuOpen ? 'open' : ''}`}></span>
          <span className={`hamburger-line ${isMenuOpen ? 'open' : ''}`}></span>
          <span className={`hamburger-line ${isMenuOpen ? 'open' : ''}`}></span>
        </button>
      </div>

      {isMenuOpen && (
        <div className="mobile-menu">
          <div className="mobile-lang-switcher">
            {Object.entries(langLabels).map(([code, label]) => (
              <button
                key={code}
                onClick={() => { changeLanguage(code); setIsMenuOpen(false); }}
                className={`lang-btn ${language === code ? 'active' : ''}`}
              >
                {label}
              </button>
            ))}
          </div>
          <button onClick={() => scrollToSection('highlights')} className="mobile-nav-link">
            {t('nav.highlights')}
          </button>
          <button onClick={() => scrollToSection('location')} className="mobile-nav-link">
            {t('nav.location')}
          </button>
          <button onClick={() => scrollToSection('amenities')} className="mobile-nav-link">
            {t('nav.amenities')}
          </button>
          <button onClick={() => scrollToSection('reviews')} className="mobile-nav-link">
            {t('nav.reviews')}
          </button>
          <button onClick={() => scrollToSection('booking')} className="mobile-nav-link">
            {t('nav.availability')}
          </button>
          <button onClick={handleWhatsAppClick} className="mobile-cta-button">
            <MessageCircle className="h-4 w-4" />
            {t('nav.whatsappContact')}
          </button>
        </div>
      )}
    </header>
  );
};
